import React from "react";
import constructionImage from "./assets/construction-image.png";

const LandingPage = () => {
  return (
    <div className="relative flex items-center justify-center w-full min-h-screen bg-gray-100">
      <img
        src={constructionImage}
        alt="Landing Page"
        className="object-cover w-full h-screen"
        style={{ objectFit: "cover" }}
      />
      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70">
        <h1 className="text-4xl font-bold text-white opacity-90">
          TBPP under construction
        </h1>
      </div>
    </div>
  );
};

export default LandingPage;
